function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: none;stroke: #2238cb;stroke-linecap:round;stroke-linejoin:round;stroke-width: 5 } \n\t");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "shp0",
  d: "M50 24.35L50 26.51C50 31.58 48.36 36.51 45.32 40.57C42.29 44.63 38.02 47.6 33.16 49.04C28.3 50.47 23.11 50.3 18.36 48.54C13.6 46.79 9.54 43.54 6.79 39.29C4.03 35.04 2.72 30.01 3.05 24.95C3.38 19.9 5.34 15.08 8.64 11.23C11.93 7.38 16.38 4.69 21.32 3.58C26.26 2.46 31.44 2.97 36.06 5.03"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "shp0",
  d: "M50 8L26.15 31L19 24.11"
});

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 53",
    width: 53,
    height: 53,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.076f7897.svg";
export { ForwardRef as ReactComponent };